import { Segmented, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLanguageStore } from '../../store/languageStore';
import { providerMeApi } from '../../api/providerMeApi';
import { LANGUAGE_OPTIONS } from '../../i18n/languageOptions';
import { telegram } from '../../utils/telegram';
import { useAuthStore } from '../../store/authStore';
import type { LanguageCode } from '../../types/i18n';

interface LanguageSwitcherCardProps {
  supportedLanguages: LanguageCode[];
}

/**
 * Tilni almashtirish Segmented kontrolyari. "Card chrome"siz —
 * tashqi konteyner (SectionShell yoki shunga o'xshash) tomonidan beriladi.
 */
export function LanguageSwitcherCard({
  supportedLanguages,
}: LanguageSwitcherCardProps) {
  const { t } = useTranslation('provider');
  const { currentLanguage, setLanguage } = useLanguageStore();
  const setUser = useAuthStore((s) => s.setUser);

  if (supportedLanguages.length <= 1) return null;

  const options = LANGUAGE_OPTIONS
    .filter((opt) => supportedLanguages.includes(opt.value))
    .map((opt) => ({ label: `${opt.flag} ${opt.label}`, value: opt.value }));

  const handleChange = (value: string | number) => {
    const lang = value as LanguageCode;
    const previous = currentLanguage;

    setLanguage(lang);
    telegram.hapticFeedback.impact('light');

    void providerMeApi
      .updateLanguage(lang)
      .then((res) => {
        setUser({ preferredLanguage: res.preferredLanguage });
      })
      .catch((err: unknown) => {
        const error = err as {
          response?: { status?: number; data?: { code?: string; message?: string } };
        };
        const code = error?.response?.data?.code;
        const fallback =
          code === 'LANGUAGE_NOT_SUPPORTED'
            ? t('languageSwitcher.errorLanguageNotSupported')
            : code === 'INVALID_LANGUAGE_CODE'
              ? t('languageSwitcher.errorInvalidCode')
              : t('languageSwitcher.errorSaving');
        setLanguage(previous);
        telegram.hapticFeedback.notification('error');
        void message.error(fallback);
      });
  };

  return (
    <Segmented
      value={currentLanguage}
      options={options}
      onChange={handleChange}
      block
      style={{ borderRadius: 10 }}
    />
  );
}
